module.exports = __webpack_public_path__ + "img/cashback_img.80242757.png";